const STORAGE_KEY = "ui-kit-brand"
const DEFAULT_BRAND = "reality"

// localStorage can throw (blocked site data, strict private mode) — the
// switcher must keep working without persistence in that case
function readSavedBrand() {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

function saveBrand(brand) {
  try {
    localStorage.setItem(STORAGE_KEY, brand)
  } catch {
    // persistence unavailable — switching still works for the session
  }
}

function getBrandLinks() {
  return document.querySelectorAll("link[rel='stylesheet'][data-brand]")
}

function applyBrand(brand) {
  getBrandLinks().forEach((link) => {
    // media toggling instead of `disabled`: all brand stylesheets are
    // downloaded up front, so switching is instant and consistent across browsers
    link.media = link.dataset.brand === brand ? "all" : "not all"
  })
  document.body.dataset.brand = brand
  document
    .querySelectorAll("[data-brand-switcher] .brand-switcher__btn")
    .forEach((btn) => {
      btn.setAttribute("aria-pressed", String(btn.dataset.brand === brand))
    })
}

function initBrandSwitcher() {
  const root = document.querySelector("[data-brand-switcher]")
  if (!root) return

  const knownBrands = new Set(
    Array.from(getBrandLinks(), (link) => link.dataset.brand),
  )
  const saved = readSavedBrand()
  applyBrand(knownBrands.has(saved) ? saved : DEFAULT_BRAND)

  root.addEventListener("click", (e) => {
    const btn = e.target.closest(".brand-switcher__btn")
    if (!btn) return
    const brand = btn.dataset.brand
    if (!brand || !knownBrands.has(brand)) return
    saveBrand(brand)
    applyBrand(brand)
  })
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBrandSwitcher)
} else {
  initBrandSwitcher()
}
